import React from 'react';

const Experience = () => {
  const experiences = [
    {
      title: "Webdesigner",
      description: "49 Jahre Erfahrung in der digitalen Welt"
    },
    {
      title: "2. Vorsitzender AWO Lauingen",
      description: "Soziales Engagement für unsere Gemeinschaft"
    },
    {
      title: "Mitglied im Vorstand AWO-Kreisverband Dillingen",
      description: "Regionale Vernetzung und Zusammenarbeit"
    },
    {
      title: "Aktiver Helfer Tafel Dillingen - Ausgabestelle Lauingen",
      description: "Praktische Hilfe für Bedürftige vor Ort"
    },
    {
      title: "Stellvertretender Kreisvorsitzender FDP Dillingen",
      description: "Politische Führungsverantwortung"
    },
    {
      title: "Stellvertretender Ortsvorsitzender FDP Lauingen",
      description: "Lokale politische Arbeit"
    },
    {
      title: "Bezirks- und Landesdelegierter AWO Schwaben e.V.",
      description: "Überregionale Vernetzung"
    },
    {
      title: "Bezirks- und Landesdelegierter FDP Bayern",
      description: "Politische Mitgestaltung auf Landes- und Bezirksebene"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">Meine Erfahrung</h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Über Jahre hinweg habe ich Erfahrungen in verschiedenen Bereichen gesammelt, 
            die mir heute bei der politischen Arbeit für Lauingen zugutekommen.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {experiences.map((experience, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-lg font-bold text-blue-600 mb-3">
                {experience.title}
              </h3>
              <p className="text-gray-600">
                {experience.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;